//* 소수점을 버리면 뒤이어 친 자릿수가 정수부에 붙어 금액이 100배가 된다 — 소수 그대로 읽어 단위 검증에 맡긴다
export const parseAmountInput = (value: string) =>
  /^[\d,]*(\.\d*)?$/.test(value) ? Number(value.replaceAll(',', '')) : null;
